export const media = {
  xs: { maxWidth: 550 },
  sm: { maxWidth: 768 },
  md: { maxWidth: 1024 },
  lg: { maxWidth: 1280 },
  xl: { maxWidth: 1536 },
  gtXs: { minWidth: 551 },
  gtSm: { minWidth: 769 },
  gtMd: { minWidth: 1025 },
  gtLg: { minWidth: 1281 },
  short: { maxHeight: 820 },
  tall: { minHeight: 821 },
  hoverNone: { hover: 'none' },
  pointerCoarse: { pointer: 'coarse' },
  dark: { colorScheme: 'dark' },
  light: { colorScheme: 'light' },
}
export type AppMedia = typeof media


